import { createSlice, PayloadAction } from "@reduxjs/toolkit";

export interface HTMLDrawerState {
  isOpen: boolean;
  htmlContent: string | null;
  reportName: string | null;
  loading: boolean;
  error: string | null;
}

const initialState: HTMLDrawerState = {
  isOpen: false,
  htmlContent: null,
  reportName: null,
  loading: false,
  error: null,
};

const htmlDrawerSlice = createSlice({
  name: "htmlDrawer",
  initialState,
  reducers: {
    openHTMLDrawer: (
      state,
      action: PayloadAction<{ htmlContent: string; reportName: string }>
    ) => {
      state.isOpen = true;
      state.htmlContent = action.payload.htmlContent;
      state.reportName = action.payload.reportName;
      state.loading = false;
      state.error = null;
    },
    closeHTMLDrawer: (state) => {
      state.isOpen = false;
      state.htmlContent = null;
      state.reportName = null;
      state.loading = false;
      state.error = null;
    },
    setHTMLDrawerLoading: (state, action: PayloadAction<boolean>) => {
      state.loading = action.payload;
    },
    setHTMLDrawerError: (state, action: PayloadAction<string>) => {
      state.error = action.payload;
      state.loading = false;
    },
  },
});

export const {
  openHTMLDrawer,
  closeHTMLDrawer,
  setHTMLDrawerLoading,
  setHTMLDrawerError,
} = htmlDrawerSlice.actions;

export default htmlDrawerSlice.reducer;
